import { c as _c } from "react/compiler-runtime";
import { useChips } from "@website/ui/chips/chips.hook";
import styles from "@website/ui/chips/chips.module.scss";
import { ChipsPropertiesType } from "@website/ui/chips/chips.types";
import { LazyImage } from "@website/ui/lazy-image";
import { FC } from "react";
export const Chips: FC<ChipsPropertiesType> = properties => {
  const $ = _c(23);
  const {
    disabled,
    EndIcon,
    StartIcon,
    selected,
    variant,
    color,
    text,
    avatar,
    alt,
    className,
    transparent,
    textStyle,
    tooltip,
    textClassName,
    datatestid
  } = properties;
  const {
    endIconProperties,
    rootProperties
  } = useChips(properties);
  const t0 = `${styles.chips} ${styles[variant || "contained"]} ${styles[color || "primary"]} ${disabled ? styles.disabled : ""} ${selected ? styles.selected : ""} ${className}`;
  let t1;
  if ($[0] !== color || $[1] !== transparent) {
    t1 = color?.startsWith("#") ? {
      color: transparent ? color : "white",
      backgroundColor: transparent ? `${color}20` : color
    } : {};
    $[0] = color;
    $[1] = transparent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== StartIcon || $[4] !== alt || $[5] !== avatar) {
    t2 = avatar ? <LazyImage alt={alt} className={styles.image} src={avatar} /> : StartIcon ? <div className={styles["start-icon"]}>{StartIcon}</div> : null;
    $[3] = StartIcon;
    $[4] = alt;
    $[5] = avatar;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `${textClassName} ${styles.text} ${textStyle}`;
  let t4;
  if ($[7] !== t3 || $[8] !== text) {
    t4 = <div className={t3}>{text}</div>;
    $[7] = t3;
    $[8] = text;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== EndIcon || $[11] !== endIconProperties) {
    t5 = EndIcon ? <div {...endIconProperties} className={styles["end-icon"]}>{EndIcon}</div> : null;
    $[10] = EndIcon;
    $[11] = endIconProperties;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.overlay} />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== datatestid || $[15] !== rootProperties || $[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t4 || $[20] !== t5 || $[21] !== tooltip) {
    t7 = <div {...rootProperties} className={t0} style={t1} title={tooltip} data-testid={datatestid}>{t2}{t4}{t5}{t6}</div>;
    $[14] = datatestid;
    $[15] = rootProperties;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t4;
    $[20] = t5;
    $[21] = tooltip;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};